import { SelectOptionValue } from 'app/area/code-selector/types';
import { includeChildrenOnSearch } from 'app/area/list-view-code-selector/constants';

export const getOptions = (searchInput: string, options: SelectOptionValue[]) =>
  !shouldDisplaySingleFlexibleColumn(searchInput)
    ? options
    : filterOptionsBySearchInput(searchInput, options, [])
      ?.filter(filterFoldersOut)
      ?.map(mapOptionToFlatOption);

export const shouldDisplaySingleFlexibleColumn = (searchInput: string) => searchInput !== '' && searchInput !== undefined;

const filterOptionsBySearchInput = (searchInput: string, options: SelectOptionValue[], resultOptions: SelectOptionValue[],
  path: SelectOptionValue[] = []): SelectOptionValue[] => {
  if (!options || options.length === 0) {
    return resultOptions;
  }

  return options.reduce((resultOptionsInternal, option) => hasDescendants(option)
    ? findOptionsInDescendants(searchInput, option, resultOptionsInternal, path)
    : findInOption(searchInput, option, resultOptionsInternal, path), resultOptions);
};

const hasDescendants = (option: SelectOptionValue) => !!option.descendants && option.descendants.length > 0;

const mapOptionToFlatOption = (option: SelectOptionValue): SelectOptionValue => ({
  ...option, descendants: undefined
});

const findOptionsInDescendants = (searchInput: string, option: SelectOptionValue, resultOptions: SelectOptionValue[],
  path: SelectOptionValue[]): SelectOptionValue[] => includeChildrenOnSearch && includesSearchedPhrase(searchInput, option)
    ? [...resultOptions, ...option.descendants.map(descendant => ({ ...descendant, fullPath: [...path, mapOptionToFlatOption(option)] }))]
    : filterOptionsBySearchInput(searchInput, option.descendants, resultOptions, [...path, option]);

const includeOptionInResult = (resultOptions: SelectOptionValue[], option: SelectOptionValue, path: SelectOptionValue[]):
  SelectOptionValue[] => [...resultOptions, { ...option, fullPath: path.map(pathItem => mapOptionToFlatOption(pathItem)) }];

const findInOption = (searchInput: string, option: SelectOptionValue, resultOptions: SelectOptionValue[],
  path: SelectOptionValue[]): SelectOptionValue[] => includesSearchedPhrase(searchInput, option)
    ? includeOptionInResult(resultOptions, option, path)
    : resultOptions;

const includesSearchedPhrase = (searchInput: string, option: SelectOptionValue) =>
  extractSearchPhraseWords(searchInput?.toLowerCase())?.every(word => option.description?.toLowerCase()?.includes(word));

const extractSearchPhraseWords = (searchInput: string): string[] => searchInput.split(' ');

const filterFoldersOut = (option: SelectOptionValue): boolean => !option.descendants || option.descendants.length === 0;
